import GetAnalyticsForOrganisationRequestModelBase from '../_generated/modelBases/get-analytics-for-organisation-request-model-base';

export default class GetAnalyticsForOrganisationRequestModel extends GetAnalyticsForOrganisationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
